export enum AssignmentStatsType {
  ALL = 'all',
  SOME = 'some',
  NONE = 'none',
}

export interface AssigneeAttributes {
  name: string;
  email: string;
  status: string;
  avatarUrl: string;
  disabled?: boolean;
}

export interface AssignmentStats {
  assignedTo: AssignmentStatsType;
  assignedTaskCount: number;
  totalTaskCount: number;
}

export interface AvailableAssignee extends AssigneeAttributes {
  id: string;
}

export interface AvailableAssigneeWithAssignmentStats
  extends AvailableAssignee {
  assignmentStats: AssignmentStats;
}

export interface AvailableAssigneeWithCheckedStatus extends AvailableAssignee {
  checked: boolean | 'mixed';
}
